import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CmsConfig, I18nModule, provideConfig, UrlModule} from '@spartacus/core';
import {GenericLinkModule, MediaModule} from '@spartacus/storefront';

import {AimoSpinnerModule} from '../spinner/aimo-spinner.module';

import {AimoCarouselModule} from "../carousel/aimo-carousel.module";
import {AimoProductListModule} from "../../product/product-list/aimo-product-list.module";
import {AimoCmsCarouselModule} from "../carousel/cms/aimo-cms-carousel.component.module";
import {AimoTabbedContainerComponent} from "./aimo-tabbed-container.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        I18nModule,
        MediaModule,
        GenericLinkModule,
        AimoSpinnerModule,
        AimoCarouselModule,
        AimoProductListModule,
        AimoCmsCarouselModule,
    ],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                AimoTabbedContainerComponent: {
                    component: AimoTabbedContainerComponent,
                },
            },
        }),
    ],
    declarations: [AimoTabbedContainerComponent],
    exports: [AimoTabbedContainerComponent],
})
export class AimoTabbedContainerModule {
}
